// extracted by mini-css-extract-plugin
export default {"download":"Documents_download__VM1VR"};